import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CmInterceptHeaders } from '../models';
import { CmAuthService, CmSettingsService, CmTimeoutService, TWO_STEP_STORE } from '../services';

@Injectable({
	providedIn: 'root',
})
export class CmAuthTokenInterceptor implements HttpInterceptor {
	constructor(
		private auth: CmAuthService,
		private settings: CmSettingsService,
		private router: Router,
		private timeoutService: CmTimeoutService
	) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const bypassAuth = req.headers.has(CmInterceptHeaders.Type.BypassAuth);
		if (bypassAuth) {
			req = req.clone({
				headers: req.headers.delete(CmInterceptHeaders.Type.BypassAuth),
			});
		}
		const token = this.auth.getAuthToken();
		const twoStepToken = this.auth.getTwoStepToken();

		if (!bypassAuth) {
			req = req.clone({
				headers: req.headers.set('authorization', `Bearer ${token}`),
			});
			if (twoStepToken) {
				req = req.clone({
					headers: req.headers.set(TWO_STEP_STORE, twoStepToken),
				});
			}
		}

		const ignoreAuthError = req.headers.has(CmInterceptHeaders.Type.IgnoreAuthError);

		if (!ignoreAuthError && !bypassAuth && !this.auth.validateTokenAgainstSnapshot()) {
			this.auth.logout$();
		}

		return next.handle(req).pipe(
			catchError(err => {
				if (token && !ignoreAuthError) {
					if (err.status === 401 || err.statusCode === 401) {
						this.auth.logout$();
					} else if (err.status === 403 || err.statusCode === 403) {
						this.redirectToAccessDenied();
					}
				}
				const error = err.error ? err.error : err;

				return throwError(error);
			})
		);
	}

	private redirectToAccessDenied(): void {
		this.router.navigate(this.settings.route(['access-denied']));
	}
}
